import { Reducer } from 'redux';
import { FlashlightSearchActionTypes } from './actions';

// Type-safe initialState!
const initialState = {
  response: null,
  counties: []
};

type IFlashlightSearchStoreState = Readonly<typeof initialState>;

const reducer: Reducer<IFlashlightSearchStoreState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FlashlightSearchActionTypes.SEARCH: {
      //console.log('search result:', action.value);
      let _state = { ...state };
      _state = { ..._state, response: action.value };
      return _state;
    }
    case FlashlightSearchActionTypes.LOAD_COUNTIES_INTO_STORE: {
      //console.log('search result:', action.value);
      let _state = { ...state };
      _state = { ..._state, counties: action.value };
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
